module.exports = __webpack_public_path__ + "static/media/thunderstorm-moon.37c76a46.svg";